module.exports = __webpack_public_path__ + "static/backdrop@2x-8d92c6763b3272c38a39c96700193a7a.png";